import { render, staticRenderFns } from "./QuesList.vue?vue&type=template&id=0e02e78b&scoped=true"
import script from "./QuesList.vue?vue&type=script&lang=ts"
export * from "./QuesList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./QuesList.vue?vue&type=style&index=0&id=0e02e78b&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0e02e78b",
  "6273cb15"
  
)

export default component.exports